/**
 * Skills by sport (sql/046), for a coach who teaches padel and tennis: one
 * group per sport that has any, padel first, each with its sport for a
 * heading. For a padel-only coach a single group with no sport, so the
 * screen looks exactly as it did.
 */
export type SportKey = 'padel' | 'tennis';

export function sportGroups<T extends { sport?: string | null }>(items: T[], coachSports: readonly string[] = ['padel']) {
  if (!coachSports.includes('tennis')) return [{ sport: null as SportKey | null, items }];
  return (['padel', 'tennis'] as const)
    .map((sport) => ({ sport: sport as SportKey | null, items: items.filter((x) => (x.sport ?? 'padel') === sport) }))
    .filter((g) => g.items.length > 0);
}
